import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useSelector } from "react-redux";
import Datetime from "react-datetime";
import { Link, useNavigate } from "react-router-dom";
import useAxiosFile from "../../actions/useaxios";
import { Nav, Tab, Row, Col, Modal } from "react-bootstrap";
import { DateTimeForm } from "../../actions/common";
import { useParams } from "react-router-dom";


function Chatlists() {
  const [shopModal, setShopModal] = useState(false);
  const { toggle, payload, token } = useSelector(
    (state) => state.seller_panel.User
  );
  const navigate = useNavigate();
  const axiosFile = useAxiosFile();
  const [filterdatas, SetFilterDatas] = useState({});
  const [chatlist, SetChatlist] = useState([]);
  const [search, setSearch] = useState('');


  useEffect(() => {
    if (payload?._id) {
      GetChatlist();
    }
  }, [payload?._id, search]);


  // const GetOrders = async (filter) => {
  //   filter = { ...filterdatas, ...(filter ? filter : {}) };
  //   if (filter) {
  //     filter.startdate = filter.startdate
  //       ? filter.startdate.getTime()
  //       : undefined;
  //     filter.enddate = filter.enddate ? filter.enddate.getTime() : undefined;
  //   }

  //   let senddata = {
  //     action: "get",
  //     filter: filter,
  //     SellerId: payload?._id,
  //   };
  //   var resp = await axiosFile.Getfinanceorder(senddata);
  //   console.log("dasdasdsadsa", resp);

  //   SetShopList(
  //     Array.isArray(resp?.data?.shoplist) ? resp?.data?.shoplist : []
  //   );
  //   SetOrderList(resp?.data?.orderlist);
  // };

  const GetChatlist = async () => {

    const resp = await axiosFile.getChatList({ search: search });
    console.log('GetChatlistrespppp', resp?.data, resp)
    SetChatlist(resp?.data)
  }
  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });


  const submit = async (row) => {
    let receiverId = await row?.users?.filter((item) => item?.userId != payload?._id)[0]?.userId
    navigate(`/chatbox?orderid=${row?.orderId?._id}&&receiverid=${receiverId}`)

  }


  const columns = [{
    dataField: 'id',
    text: 'S.No',
    formatter: (cell, row, rowindex) => (
      <>
        <p className="status_label">{rowindex + 1}</p>
      </>
    ),
  },
  {
    dataField: 'roomId',
    text: 'RoomId'
  },
  {
    dataField: 'OrderId',
    text: 'Orderid',
    formatter: (cell, row, rowindex) => (
      <>
        <p className="status_label">{row?.orderId?.OrderNumber}</p>
      </>
    ),
  },
  {
    dataField: 'action',
    text: 'Action',
    formatter: (cell, row, rowindex) => (
      <>
        {/* <div onClick={()=>submit(row)}>

      </div> */}
        <Link onClick={() => submit(row)}

          className="viewbtn"
        > View</Link>
      </>
    ),
  }];



  const OnChange = async (e, from) => {
    // console.log("khdkjddada", e, from);
    // if (from == "shop") {
    //   SetFilterDatas({ ...filterdatas, [from]: e?.value });
    //   GetOrders({ [from]: e?.value });
    // } else if (from.includes("date")) {
    //   SetFilterDatas({ ...filterdatas, [from]: e?._d });

    //   setOpacity("true");
    //   GetOrders({ [from]: e?._d });
    // } else if (from == "ordernumber") {
    //   SetFilterDatas({ ...filterdatas, [from]: e?._d });
    //   GetOrders({ [from]: e?.target?.value });
    // }
  };

  return (
    <section
      id="content-wrapper"
      style={{ marginTop: "30px" }}
      className=" dly_rpt_inr"
    >
      <div class="row mx-auto">
        <div className="col-12 col-xl-3  d-flex align-items-start align-items-xl-center ">
          <p className="page_title mb-0">Chat lists</p>
        </div>
        <div className="col-12 col-xl-9 mt-sm-4 mt-xl-0  d-flex flex-column flex-md-row align-items-end justify-content-md-end">
          {" "}
          <Row className="adm_inpt_wrp align-items-center me-1 me-md-3 my-3 my-sm-0 mb-sm-3 mb-md-0">
            <Col xs={11}>
              <input
                type="text"
                placeholder="search roomid"
                onChange={(e) => setSearch(e.target.value)}
                value={search || ''}
              />
            </Col>
            <Col
              xs={1}
              className="ps-0 d-flex justify-content-end"
            >
              {/* <i class="fa fa-search"></i> */}
            </Col>
          </Row>
          <div className="rightside mt-0 justify-content-end">




            {/* <div className="order_calendar_div ">
                              {
                                filterdatas?.startdate ?
                                  <p></p>
                                  :
                                  <p
                                    className={
                                      opacity == "true" ? "hiding_caltxt" : ""
                                    }
                                  >
                                    Start Date
                                  </p>
                              }
                              <img
                                className="order_calendar_ic"
                                src={require("../../assets/images/calendar.png")}
                                alt="calendar"
                              />
                              <Datetime
                                onChange={(e) => {
                                  OnChange(e, "startdate");
                                }}
                                value={filterdatas?.startdate}
                                className="order_datepick"
                              />
                            </div> */}

            {/* <div className="order_calendar_div">
                              {
                                filterdatas?.enddate ?
                                  <p></p>
                                  :
                                  <p
                                    className={
                                      opacity == "true" ? "hiding_caltxt" : ""
                                    }
                                  >
                                    End Date
                                  </p>
                              }

                              <img
                                className="order_calendar_ic"
                                src={require("../../assets/images/calendar.png")}
                                alt="calendar"
                              />
                              <Datetime
                                onChange={(e) => {
                                  OnChange(e, "enddate");
                                }}
                                value={filterdatas?.enddate}
                                className="order_datepick"
                              />
                            </div> */}


                          </div>
                        </div>
                      </div>
                      <div className="row mx-auto">
                        {chatlist?.length > 0 ? (
                          <div className="ffd_table mar_bot min_ht_none px-0 table_bor row">
                            <BootstrapTable
                              bootstrap4
                              keyField="id"
                              columns={columns}
                              data={chatlist}
                              pagination={pagination}
                              noDataIndication="No Chat found"
                            />
                          </div>
                        )
                          :
                          <div className="nodatasec">
                            <p>
                              No Data Found

                            </p>

                          </div>

                        }
                      </div>
                    </section>
  );
}

export default Chatlists;
